<div class="fixedfilters">
    <div *ngIf="showFidoliWarning" class="fidoli-software">
        <mat-icon matTooltip="{{ 'FidoliSoftwareWarning' | translate }}">warning</mat-icon>
    </div>

    <div *ngIf="notch && !!notch.value" class="filter">
        <img alt="Notch" src="assets/images/Notch.png" />
        <label>{{ notch.value }} Hz</label>
    </div>

    <div class="break"></div>

    <div *ngIf="highPass && !!highPass.value" class="filter">
        <img alt="High-Pass filter" src="assets/images/HighPass.png" />
        <label>{{ highPass.value }} Hz</label>
    </div>

    <div class="break"></div>

    <div *ngIf="lowPass && !!lowPass.value" class="filter">
        <img alt="Low-Pass filter" src="assets/images/LowPass.png" />
        <label *ngIf="schillerFilters?.lowFilter > 0">{{ schillerFilters?.lowFilter }} Hz</label>
        <label *ngIf="schillerFilters?.lowFilter <= 0">{{ lowPass.value }} Hz</label>
    </div>
</div>
